export const logger = {
    log: message => window.console.log(message)
}

export default {

    // called by Vue.use(logger)
    install(Vue) {
        Vue.prototype.$log = logger.log;
    }
}